import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import Loader from '../components/ui/loader';
import { getHighestAvailableUrl } from '../helpers/urlHelper';

export default function PublicRoute() {
  const { isAuthenticated, loading, loggingOut, user } = useSelector((state) => state.auth);

  const landingUrl = getHighestAvailableUrl(user?.role);

  // Better auth state messaging
  if (loading || loggingOut) {
    let message = 'Please wait...';

    if (loggingOut) message = 'See you soon...';
    else if (loading) message = 'Processing...';

    return <Loader loading message={message} />;
  }

  return isAuthenticated ? <Navigate to={landingUrl} replace /> : <Outlet />;
}
